import CurrencyInput, { CurrenctInputProps } from "@components/form/CurrencyInput";
import { Currency } from "@lib/enums/generic";
import { UIColor } from "@lib/types/generic";
import { getCurrencySymbol } from "@lib/utils/generic";
import { useState } from "react";
import { Group, Showcase } from "./StyleGuide";

const CurrencyInputs = () => {
  const sizes = [
    "extra-small",
    "small",
    "medium",
    "large",
    "extra-large",
  ] as CurrenctInputProps["size"][];

  const [value, setValue] = useState(0);
  const [color, setColor] = useState<UIColor>("purple");
  const [textColor, setTextColor] = useState<UIColor>("white");
  const [variant, setVariant] = useState<CurrenctInputProps["variant"]>("contained");
  const [disabled, setDisabled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [rounded, setRounded] = useState<boolean>(false);

  const props = {
    value,
    onChange: ({ value }: { value: number }) => setValue(value),
    onBlur: ({ value }: { value: number }) => setValue(value),
    color,
    textColor,
    variant,
    disabled,
    isLoading,
    rounded,
  };

  return (
    <Showcase
      title="Currency Inputs"
      className="currency-inputs"
      colors={[
        {
          color: color,
          label: "Color",
          onChange: setColor,
        },
        {
          color: textColor,
          label: "Text Color",
          onChange: setTextColor,
        },
      ]}
      selects={[
        {
          value: variant ?? "contained",
          optionsArray: ["contained", "outlined", "flat", "transparent"],
          label: "Variant",
          onChange: setVariant,
        },
      ]}
      checkboxes={[
        {
          value: disabled,
          label: "Disabled",
          onChange: setDisabled,
        },
        {
          value: isLoading,
          label: "Is loading",
          onChange: setIsLoading,
        },
        {
          value: rounded,
          label: "Rounded",
          onChange: setRounded,
        },
      ]}>
      {sizes.map(size => (
        <Group key={size}>
          <CurrencyInput size={size} {...props} currency={getCurrencySymbol(Currency.GBP)} />
          <CurrencyInput size={size} {...props} currency={getCurrencySymbol(Currency.USD)} />
          <CurrencyInput size={size} {...props} currency={getCurrencySymbol(Currency.CAD)} />
          <CurrencyInput size={size} {...props} currency={getCurrencySymbol(Currency.AUD)} />
        </Group>
      ))}
    </Showcase>
  );
};

export default CurrencyInputs;
